module.exports = __webpack_public_path__ + "static/media/typescript.cf2eeeb8.png";